// extracted by mini-css-extract-plugin
export default {"Rcard":"ReferralCard_Rcard__7ZHfR","ReferralTxt":"ReferralCard_ReferralTxt__y9Qqq"};